import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { formatNumber } from '@progress/kendo-intl';

const PayloadCell = (props: GridCustomCellProps) => {
  if (!props.field) return null;

  return (
    <td {...props.tdProps}>
      {formatNumber(props.dataItem.Payload, 'n0')}<br />
      {props.dataItem.Dims}
    </td>
  );
}

export default React.memo(PayloadCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
